export const Colors = {
  background: "hsl(208, 100%, 98.2%)",
  text: "hsl(208, 69%, 13%)",
  secondaryText: "#FFFFFF",
  primary: "hsl(208, 100%, 50%)",
  secondary: "hsl(208, 87%, 36%)",
  secondaryBackground: "hsl(205, 100%, 90%)",
};

export const apiBaseURL = "https://vasanimit9-backend.herokuapp.com";

export const localStorageKeys = {
  frontPage: `${apiBaseURL}-frontpage`,
  experiences: `${apiBaseURL}-experiences`,
  projects: `${apiBaseURL}-projects`,
  posts: `${apiBaseURL}-posts`
}

export const Dimens = {
  sidebar: 60,
  mobileMaxWidth: 480,
  tabletMaxWidth: 768,
  borderRadius: 3,
};

export const strings = {
  repo: "👨‍💻 Repo",
  demo: "🌐 Demo",
};
